import gsap from "gsap";
import structure from "../../assets/REMA/structure-Illustration.svg";
import { useGSAP } from "@gsap/react";
import { useRef } from "react";
import { REMA_SPONSORSHIP_PAGE_URL } from "./constants";

const REMAEventDetails = () => {
  const pathRef = useRef(null);

  useGSAP(() => {
    const path = pathRef.current;
    if (path) {
      const length = path.getTotalLength();
      gsap.set(path, {
        strokeDasharray: length,
        strokeDashoffset: length,
      });

      // Parallax scaling for the structure-illustration image
      const img = document.querySelector(".structure");
      if (img) {
        gsap.to(img, {
          scale: 1.15,
          scrollTrigger: {
            trigger: img,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
          ease: "power1.out",
        });
      }
      gsap.to(path, {
        strokeDashoffset: 0,
        duration: 3,
        ease: "power1.inOut",
        scrollTrigger: {
          trigger: ".container",
          start: "top 80%",
          once: true,
        },
      });
    }
  }, []);
  return (
    <div className="bg-[#11302D] py-[86px] lg:py-16 md:px-10 text-white font-sora lg:max-w-[600px] space-y-6 p-4 lg:space-y-10 overflow-hidden lg:pb-[200px] relative xl:max-h-[760px]">
      <h1
        className="text-[28px] lg:text-[36px]  md:text-[50px] xl:text-[44px] font-bold leading-[125%] text-"
        style={{ textWrap: "balance" }}
      >
        Real Estate Management in Africa{" "}
        <span className="text-[#CBF07F]">(REMA) 2025</span>
      </h1>
      <div className=" flex flex-col justify-between gap-10">
        <p className="font-bold text-[18px] md:text-[22px] leading-normal">
          Structures Beyond Buildings: <br></br>
          <span className="font-light italic">
            Managing Africa’s Urban Communities
          </span>
        </p>
        <div className="text-sm md:text-base md:gap-4 md:items-center uppercase text-white flex flex-col md:flex-row gap-2">
          <p>November 6, 2025 </p>
          <div className="bg-[#CBF07F] w-[1px] h-[20px] hidden md:block" />
          <p> The Podium, Lekki, Lagos</p>
        </div>
        <div className="flex flex-col md:flex-row gap-3 ">
          <div>
            <a
              href={REMA_SPONSORSHIP_PAGE_URL}
              className=" hover:scale-105 text-light-green-500 font-semibold py-3 px-8 transition duration-300 ease-in-out transform text-sm  w-full lg:w-fit border border-light-green-500 relative z-10 block text-center"
            >
              Become a sponsor
            </a>
          </div>
        </div>
      </div>
      <div
        className="hidden lg:block absolute left-0 -bottom-0 z-[0] w-full
            "
      >
        <svg
          width="639"
          height="350"
          viewBox="0 0 639 350"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full scale-[1.2]"
        >
          <path
            ref={pathRef}
            d="M636.497 9.63688C468.843 46.0722 286.84 97.5807 141.371 176.496C-258.614 393.481 390.608 393.439 301.6 179.688C264.14 89.7282 141.24 89.0979 14.5336 107.956"
            stroke="#19443F"
            strokeWidth="19.6623"
          />
        </svg>
      </div>
      <div
        className="hidden lg:block absolute left-1/4 -bottom-6 z-[0] w-full
            "
      >
        <img src={structure} alt="" className="structure w-full scale-[1.4]" />
      </div>
    </div>
  );
};

export default REMAEventDetails;
